(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  class CartShippingEstimate extends HTMLElement {
    connectedCallback() {
      this.valueEl = this.querySelector('[data-shipping-value]');
      this.freeThreshold = parseInt(this.dataset.freeThreshold, 10) || 0;
      this.freeText = this.dataset.freeText || '';
      this.priceText = this.dataset.priceText || '';

      this.drawer = this.closest('cart-drawer');
      this.countEl = this.drawer && this.drawer.querySelector('#NewCartCount');
      if (this.countEl) {
        this.observer = new MutationObserver(() => this.schedule());
        this.observer.observe(this.countEl, { childList: true, subtree: true, characterData: true });
      }

      this.refresh();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      clearTimeout(this.timer);
    }

    schedule() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.refresh(), 200);
    }

    set(html) {
      if (this.valueEl && this.valueEl.innerHTML !== html) this.valueEl.innerHTML = html;
    }

    async refresh() {
      try {
        const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
        const isFree = this.freeThreshold > 0 && cart.total_price >= this.freeThreshold;
        this.set(isFree ? this.freeText : this.priceText);
      } catch (error) {
      }
    }
  }

  if (!customElements.get('cart-shipping-estimate')) {
    customElements.define('cart-shipping-estimate', CartShippingEstimate);
  }
})();
